(function () {
    "use strict";

    angular.module("app").factory('personService_Check', PersonServiceFactory);
    PersonServiceFactory.$inject = ['$http', 'settingsService'];
    function PersonServiceFactory($http, settingsService) {

        return {
            // USED
            getRequest: getRequest,
        };

        function getRequest(requestId, callback, errorCallback) {
            if (requestId.toLowerCase() === "request") {
                requestId = "";
            }

            $http.get(settingsService.applicationPath + 'api/Person/getProccess/?requestId=' + requestId)
                .then(callback,
                    function (result, status, headers, config) {
                        errorCallback(result.data, status, headers, config);
                    });
        }
    }
})();
